<template>
    <div class="flex items-center md::w-[18.75rem] w-full md:max-w-[18.75rem]">
        <input
            v-model="inputValue"
            class="input-base"
            inputmode="email"
            autocomplete="off"
            maxlength="8"
            type="text"
            :placeholder="placeholder"
            @input="emitValue"
        >
        <div
            class="btn btn-ghost flex-shrink-0 cursor-pointer p-0 "
            @click="refreshCode"
        >
            <InputIdentifyCanvas :identifyCode="identifyCode" />

            <svg
                class="text-gray-700 w-5 h-5"
                viewBox="0 0 20 20"
            >
                <path
                    fill="currentColor"
                    d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
                />
            </svg>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import InputIdentifyCanvas from '@/components/inputs/InputIdentifyCanvas.vue';

export default {
    components: {
        InputIdentifyCanvas
    },
    props: {
        // user輸入的驗證碼
        value: {
            type: String,
            required: true
        },
        // 錯誤訊息
        errorMsg: {
            type: String,
            default: ''
        },
        // 輸入框的placeholder
        placeholder: {
            type: String,
            default: ''
        },
        // 輸入框的inputmode
        inputmode: {
            type: String,
            default: 'email'
        },
        reFresh: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:value', 'validateValue', 'update:reFresh'],
    setup(props, { emit }) {
        const inputValue = ref(props.value);
        // 產出的驗證碼
        const identifyCode = ref('');
        // 驗證碼字元
        const IdentifyCodes = '1234567890';

        /**
         * 隨機產出index位置
         * @param {Number} min 陣列起點
         * @param {Number} max 陣列位置
         * @return {Number} 隨機產出index位置
         */
        const randomNum = (min, max) => {
            return Math.floor(Math.random() * (max - min) + min);
        };

        /**
         * 驗證碼製作
         * @param {Number} n 驗證碼需要幾碼
         */
        const makeCode = (n) => {
            for (let i = 0; i < n; i++) {
                const idx = randomNum(0, IdentifyCodes.length);
                identifyCode.value += IdentifyCodes[idx];
            }
        };

        // 刷新驗證碼
        const refreshCode = () => {
            identifyCode.value = '';
            emit('update:reFresh', false);
            makeCode(4);
        };

        // 回傳父層
        const emitValue = (e) => {
            emit('update:value', e.target.value);
            emit('validateValue', e.target.value === identifyCode.value);
        };

        onMounted(() => {
            makeCode(4);
        });

        watch(() => props.value, (nV) => {
            inputValue.value = nV;
        });

        watch(() => props.reFresh, (nV) => {
            if (nV) {
                refreshCode();
            }
        });

        return {
            inputValue,
            identifyCode,
            refreshCode,
            emitValue
        };
    },

};
</script>
